// extracted by mini-css-extract-plugin
export default {"inputWithClear":"QuickSearchInput_inputWithClear__LhMfl"};